/**
 *
 * @module entry
 * @desc {SDK.UserProfile} entry point.
 *
 */

import UserProfileApi from './userProfileApi';

/**
 *
 * @typedef SDK.UserProfile
 * @type {Object}
 *
 * @property {UserActivityApi} UserProfileApi
 *
 */

/**
 *
 * @type {SDK.UserProfile}
 *
 */
export default {

    UserProfileApi

};



// WEBPACK FOOTER //
// ./src/userProfile/entry.js